export default "__VITE_ASSET__LrD6zZnG__"